import { render } from "./NurseLayout.vue?vue&type=template&id=ab088064&scoped=true"
import script from "./NurseLayout.vue?vue&type=script&lang=js"
export * from "./NurseLayout.vue?vue&type=script&lang=js"

import "./NurseLayout.vue?vue&type=style&index=0&id=ab088064&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab088064"]])

export default __exports__